<template>
    <div ref="tableSection">
        <div class="table-responsive">
            <table ref="listTable" class="table table-hover table-sm">
                <colgroup>
                    <col width="50">
                    <col width="210">
                    <col width="200">
                    <col>
                    <col width="200">
                </colgroup>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Date Time</th>
                        <th>Patient I/C No.</th>
                        <th>Patient Name</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-show="checkIns.length === 0">
                        <td :colspan="columnsCount" class="text-center font-italic">
                            {{isTableLoading ? "Loading Data": "No Data"}}
                        </td>
                    </tr>

                    <tr v-for="(patient, index) in checkIns" :key="index">
                        <th scope="row">{{((pagination.currentPage - 1) *pagination.pageSize ) + index + 1}}</th>

                        <td class="text-nowrap">
                            {{ patient.dateTime }}
                        </td>
                        <td class="text-nowrap">
                            {{ patient.patientIcNo ? patient.patientIcNo : '-' }}
                        </td>
                        <td class="text-nowrap">
                            {{ patient.patientName ? patient.patientName : '-' }}
                        </td>
                        <td class="text-nowrap">
                            <router-link :to="{
                                'name': 'clinic-check-in-registered-patient',
                                'query': {
                                    'ic': patient.patientIcNo,
                                    'name': patient.patientName
                                }
                            }" class="btn btn-primary btn-primary-insv btn-sm">Check in Registered Patient</router-link>
                        </td>
                    </tr>

                </tbody>
            </table>

            <pagination v-model="pagination.currentPage"
                :totalPages="pagination.totalPages"
                :scrollPosition="pagination.scrollPosition">
            </pagination>
        </div>
    </div>
</template>

<script>
import {
    convertToUserReadableDateTime
} from '@/utilities';
import pagination from '@/components/pagination';
export default {
    'name': 'ClinicPatientCheckIn',
    'components': {
        pagination
    },
    'computed': {
        currentPage () {
            return this.pagination.currentPage;
        }
    },
    'watch': {
        currentPage () {
            this.$nextTick(() => {
                this.getList();
            });
        }
    },
    data () {
        return {
            'columnsCount': 1,
            'isTableLoading': true,
            'pagination': {
                'currentPage': 1,
                'totalPages': 0,
                'pageSize': 20,
                'scrollPosition': 0
            },
            'checkIns': []
        };
    },
    mounted () {
        this.columnsCount = this.$refs.listTable.rows[0].cells.length;

        // initialize scroll position
        this.$nextTick(() => {
            this.pagination.scrollPosition = this.$refs.tableSection.getBoundingClientRect().top + window.scrollY - document.querySelector('.top-navigation').clientHeight;
        });

        this.getList();
    },
    'methods': {
        getList () {
            this.axios.post('Clinic/GetCheckIns', {
                'p': this.pagination.currentPage,
                'ps': this.pagination.pageSize
            }).then(({ data }) => {
                this.isTableLoading = false;
                let pagedResult = data.data;

                this.pagination.currentPage = pagedResult.p;
                this.pagination.totalPages = pagedResult.c;

                let list = pagedResult.l;

                this.checkIns = list.map((checkIn) => ({
                    'dateTime': convertToUserReadableDateTime(checkIn.ca),
                    'patientName': checkIn.pn,
                    'patientIcNo': checkIn.icn
                }));
            });
        }
    }
};
</script>

<style>

</style>
